export default __webpack_public_path__ + "static/media/25120405.127fcedc.png";